import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import TooltipCommon from 'components/common/TooltipCommon';
import TooltipButton from 'components/elements/buttons/TooltipButton';

import './CommonLinkDeleteButton.css';

function CommonLinkDeleteButton(props) {
  const { deleteFunction, linkItem, mini, image } = props;
  const [popupOpen, setPopupOpen] = useState(false);
  const { t } = useTranslation();

  const onPopupClose = () => {
    setPopupOpen(false);
  };

  const renderTooltipContent = () => (
    <div className="tooltip-content">
      <div className="message-text">
        <div>
          {linkItem.is_header ? 
            t("Are you sure you want to delete this header?")
            :
            (image ? t("Are you sure you want to delete this image?")
              : t("Are you sure you want to delete this link?"))
          }
        </div>
        <div>{t("You can't undo this action.")}</div>
      </div>

      <div className="buttons-block">
        <TooltipButton
          onClick={() => setPopupOpen(false)}
        >
          {t("Cancel")}
        </TooltipButton>
        <TooltipButton
          negative
          onClick={() => deleteFunction(linkItem.id)}
        >
          {t("Delete")}
        </TooltipButton>
      </div>
    </div>
  );

  const renderDeleteButton = () => (
    <div className="common-link-delete-button__component">
      <div
        className="button-container"
        onClick={() => setPopupOpen(true)}
        role="button"
        tabIndex={-1}
      >
        <div className="icon-container">
          <div className="icon" />
        </div>
        {!mini && <div className="undertext">{t("Delete")}</div>}
      </div>
    </div>
  );

  return (
    <TooltipCommon
      key={`common-delete-link-tooltip-key-${linkItem.id}`}
      overlayClassName="common-delete-link-tooltip__component"
      header={t("Delete")}
      placement="bottom"
      trigger="click"
      visible={popupOpen}
      closeIcon
      onClose={onPopupClose}
      overlay={renderTooltipContent()}
    >
      {renderDeleteButton()}
    </TooltipCommon>
  );
}

CommonLinkDeleteButton.propTypes = {
  deleteFunction: PropTypes.func.isRequired,
  linkItem: PropTypes.object.isRequired,
  mini: PropTypes.bool,
  image: PropTypes.bool,
};

CommonLinkDeleteButton.defaultProps = {
  mini: null,
  image: null,
};

export default CommonLinkDeleteButton;
